import { createClient } from '@supabase/supabase-js';

// Debug: log env variable availability at startup
const rawUrl = import.meta.env?.VITE_SUPABASE_URL;
const rawKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

console.debug('[Supabase] VITE_SUPABASE_URL present:', !!rawUrl);
console.debug('[Supabase] VITE_SUPABASE_ANON_KEY present:', !!rawKey);

// Sanitize URL - remove trailing slash which can cause fetch failures
const supabaseUrl = rawUrl ? rawUrl?.replace(/\/+$/, '')?.trim() : null;
const supabaseAnonKey = rawKey ? rawKey?.trim() : null;

const isConfigured =
  !!supabaseUrl &&
  !!supabaseAnonKey &&
  !supabaseUrl?.includes('placeholder') &&
  supabaseUrl?.startsWith('https://');

if (!isConfigured) {
  console.error(
    '[Supabase] ❌ Not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your .env file.'
  );
  console.error('[Supabase] URL value:', supabaseUrl || '(missing)');
  console.error('[Supabase] Key value:', supabaseAnonKey ? '(present)' : '(missing)');
} else {
  console.debug('[Supabase] ✅ Configured. URL:', supabaseUrl);
}

const clientOptions = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
};

// Only create a real client when properly configured
// If not configured, create a no-op stub to prevent "Failed to fetch" against placeholder URLs
export const supabase = isConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, clientOptions)
  : {
      auth: {
        getSession: async () => ({ data: { session: null }, error: null }),
        onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
        signUp: async () => ({ data: null, error: { message: 'Supabase is not configured.' } }),
        signInWithPassword: async () => ({ data: null, error: { message: 'Supabase is not configured.' } }),
        signOut: async () => ({ error: null }),
        resetPasswordForEmail: async () => ({ data: null, error: { message: 'Supabase is not configured.' } }),
        signInWithOAuth: async () => ({ data: null, error: { message: 'Supabase is not configured.' } }),
        exchangeCodeForSession: async () => ({ data: null, error: { message: 'Supabase is not configured.' } }),
      },
      from: () => ({
        select: () => ({ eq: () => ({ single: async () => ({ data: null, error: null }) }) }),
        upsert: () => ({ select: () => ({ single: async () => ({ data: null, error: null }) }) }),
        insert: () => ({ select: () => ({ single: async () => ({ data: null, error: null }) }) }),
      }),
    };

export const isSupabaseConfigured = isConfigured;
